import React from "react";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";

type Props = {
    logout: () => void;
};

export const UnconnectedAccount = (props: Props) => {
    return (
        <div className={"UnconnectedAccount d-flex flex-column justify-content-center align-items-center position-absolute"} style={{ height: "100vh", zIndex: 20, width: "100vw", top: 0, left: 0 }}>
            <OwTitle title={"unconnected_account"} className={"text-center"} leftIconName={"fad fa-user-slash"} />
            <OwLabel title={"your_account_is_unconnected"} className={"text-center"} />
            <div className={"mt-3"}>
                <OwLabel title={"logout"} fn={props.logout} />
            </div>
        </div>
    );
};
